import Product from '@/service/product'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getreworks(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getreworks(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getallproductlines(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getallproductlines(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getproducts(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getproducts(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getproduct(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getproduct(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addproduct(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.addproduct(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateproduct(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.updateproduct(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deleteproduct(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.deleteproduct(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getvendorsfromciqca(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getvendorsfromciqca(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getproductsfromciqca(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getproductsfromciqca(payload), {
        type: 'info',
        success,
        fail
      })
    },
    synchroproductsfromciqca(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.synchroproductsfromciqca(payload), {
        type: 'action',
        success,
        fail
      })
    },
    bindciqcavendor(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.bindciqcavendor(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getboms(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getboms(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getbom(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getbom(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addbom(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.addbom(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatebom(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.updatebom(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateproductline(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.updateproductline(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getordersource(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getordersource(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getsafetystocks(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.getsafetystocks(payload), {
        type: 'list',
        success,
        fail
      })
    },
    setsafetystock(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Product.setsafetystock(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
